import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import { emailAddressClientInfoInternet, thanksClientInfoInternet } from './client-info-steps'

export const clientInfoInternetScenarioA: Scenario = {
  id: 'client-info-internet-a',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.CLIENT_INFO_INTERNET,
  version: '1',
  milestones: [emailAddressClientInfoInternet.id, thanksClientInfoInternet.id],
  steps: [emailAddressClientInfoInternet, thanksClientInfoInternet],
  weight: 1,
}
